
angular.module('bmsApp.accounting', [
	'ui.router'
])
	.config([
		'$stateProvider', function config(
			$stateProvider
		) {

			$stateProvider

				.state('main.accounting', {
					abstract: true
				})

				.state('main.accounting.invoice', {
					abstract: true
				})

				.state('main.accounting.invoice.index', {
					url: '^/accounting/invoices',
					views: {
						'main@main': {
							templateUrl: "ng/accounting/templates/InvoiceIndex.html",
							controller: 'InvoiceIndexCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Invoices'}
				})

				.state('main.accounting.invoice.index.create', {
					url: '^/accounting/invoice/add',
					views: {
						'main@main': {
							templateUrl: "ng/accounting/templates/InvoiceSave.html",
							controller: 'InvoiceSaveCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Add'}
				})

			;

		}]);
